module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Calendar', {
    attrs: {
      "isEventDataUrl": _vm.isEventDataUrl,
      "noEventDataUrl": _vm.noEventDataUrl,
      "measureUrl": _vm.measureUrl
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09a55617","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/MeterReading/Task/index.vue
// module id = 1686
// module chunks = 1